/* eslint-disable graphql/template-strings */ // @connection used
import React, {PureComponent} from "react"
import {Query as QueryComponent, cursorPagination} from "@irati/utils/services/apollo"
import {Query, QueryResult} from "@irati/utils/apollo"


import {RecognitionFeedList} from "@irati/types"
import {gql} from "@irati/utils/gql"
import {EVERYTHING} from "../../constants/feedVisibility"
import RecognitionFragment from "../fragments/Recognition"
import ScheduledGroupCelebrationFragment from "../../services/fragments/ScheduledGroupCelebration"
import PollFragment from "../fragments/Poll"

const query = gql`
  query Feed($limit: Int, $cursor: String, $view: String) {
    recognitionFeed(limit: $limit, cursor: $cursor, view: $view) @connection(key: "recognition_feed", filter: ["view"]) {
      count
      limit
      cursor
      results {
        uuid
        type
        recognition {
          ...Recognition
        }
        poll {
          ...Poll
        }
        groupCelebration {
          ...ScheduledGroupCelebration
        }
      }
    }
  }
  ${RecognitionFragment}
  ${PollFragment}
  ${ScheduledGroupCelebrationFragment}
`

export interface FeedVariables {
  limit: number
  cursor: string
  view: string
}

export interface FeedData {
  recognitionFeed: RecognitionFeedList
}

export type Feed = QueryResult<FeedData, FeedVariables>

interface Props {
  variables?: FeedVariables
  fetchPolicy?: string
  useError?: boolean
  children: any
}

export const variables = {
  limit: 10,
  cursor: "",
  view: EVERYTHING
}

export const feedQuery = {
  query,
  variables
}

class TypedQuery extends Query<QueryResult> {}

export default class FeedQuery extends PureComponent<Props> {
  static defaultProps = {
    variables,
    useError: true,
    fetchPolicy: "cache-first"
  }

  render() {
    return (
      <QueryComponent {...this.props} query={query} QueryComponent={TypedQuery} notifyOnNetworkStatusChange useLoader={false}>
        {(apolloState: Feed) => {
          const fetchMore = (vars: FeedVariables) =>
            cursorPagination(
              {
                ...feedQuery,
                variables: vars
              },
              apolloState
            )
          return this.props.children({...apolloState, fetchMore})
        }}
      </QueryComponent>
    )
  }
}
